import { TranslationKey } from './../../../../types/translation/TranslationKey';

import { cloneDeep } from '@apollo/client/utilities';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { OnboardingData, OnboardingRoutes } from '../index';
import { t } from '../../../../types/translation/Translator';
import { Button } from '../../../components/Button';
import { TextInput } from '../../../components/TextInput';
import { OnboardingStep, OnboardingSubtitle, OnboardingTitle } from '../components';
import OnboardingPaneHeader from '../components/OnboardingPaneHeader';

interface OnboardingCompanyPaneProps {
  data: OnboardingData;
  setData: (data: OnboardingData) => void;
}

export default function OnboardingCompanyPane({ data, setData }: OnboardingCompanyPaneProps) {
  const navigate = useNavigate();

  return (
    <div className='grid gap-4'>
      <OnboardingPaneHeader />

      <div className='grid gap-1'>
        <OnboardingStep />
        <OnboardingTitle text={'Get Started: Choose your company name'} />
        <OnboardingSubtitle
          text={`Start by choosing your company name - this will be your profile on the platform. Inside you'll manage your stock locations, the bins and products within and the tasks and orders associated to them.`}
        />
      </div>

      <TextInput
        label={t(TranslationKey.companyName).singular.upper}
        mandatory
        placeholder={'Example: Ventory or Acme'}
        value={data.company.name}
        onChange={value => {
          data.company.name = value;
          setData(cloneDeep(data));
        }}
      />

      <Button
        className='w-fit'
        onClick={() => navigate(OnboardingRoutes.stockLocationImport)}
        text={t(TranslationKey.next).singular.label}
        disabled={!data.company.name}
      />
    </div>
  );
}
